import { OwnedRealEstate } from "@eave/shared/types/api";

// TODO: jjw: move address stuff to shared libs

const displayAddressParts = (
  line1: string,
  line2: string,
  city: string,
  state: string,
  zip: string,
): string[] => [line2 ? `${line1}, ${line2}` : line1, `${city}, ${state} ${zip}`];

export const reoToDisplayAddressParts = (reo: OwnedRealEstate): string[] => {
  if (reo.operator_address_line1) {
    return displayAddressParts(
      reo.operator_address_line1,
      reo.operator_address_line2,
      reo.operator_city,
      reo.operator_state,
      reo.operator_postal_code,
    );
  }
  return displayAddressParts(
    reo.address_line1,
    reo.address_line2,
    reo.city,
    reo.state,
    reo.postal_code,
  );
};
